import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

class CashInOut {
  create = async (category: any) => {
    const response = await axios
      .post<any>(`${API_URL}cash-in-out`, category)
      .catch((e) => {
        throw e.message;
      });

    // console.log(response); // !

    return response.data;
  };

  edit = async (category: any, code: any) => {
    await axios
      .put<any>(`${API_URL}cash-in-out/${code}`, category)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  get = async (code: any) => {
    const response = await axios
      .get<any>(`${API_URL}cash-in-out/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.cashInOut;
  };

  getAll = async () => {
    const response = await axios
      .get<any>(`${API_URL}cash-in-out`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.cashInOut;
  };

  getAllbyUser = async () => {
    const response = await axios
      .get<any>(`${API_URL}cash-in-out-user`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.cashInOut;
  };
}

export default new CashInOut();
